import $ from "jquery";
import {MarkerClusterer} from "@googlemaps/markerclusterer";
import {Loader, LoaderOptions} from 'google-maps';
import * as CookieConsent from "vanilla-cookieconsent";


export default class Maps {
    constructor() {
        this.mapDiv = document.getElementById('map');
        this.preferences = CookieConsent.getUserPreferences();
        this.loadMap()
    }

    loadMap() {
        if(!!this.mapDiv && !this.preferences.acceptedCategories.includes('maps')) {
          let consentDiv = "<div class='maps-consent'><p>Dieser Inhalt wird von Google zur Verfügung gestellt. Bitte akzeptieren Sie die Services von Google Maps in den Cookie Einstellunge. Durch anzeigen der Karte akzeptieren Sie die Geschäftsbedingungen von Google.</p>" +
              "<button data-cc='show-preferencesModal' class='btn'>Cookie Einstellungen</button></div>";
            this.mapDiv.innerHTML= consentDiv;
            this.mapDiv.classList.add('consent');
        }
        if (!!this.mapDiv && !!this.preferences.acceptedCategories.includes('maps')) {
            const wells = JSON.parse(document.querySelector('[data-wells]').dataset.wells);
            const loader = new Loader('AIzaSyBM62s_D5CHmGvQmB-9GWRZ9vG0V89DaLs');
            loader.load().then((google) => {
                let zoom = {
                    'style': google.maps.ZoomControlStyle.SMALL,
                    'position': google.maps.ControlPosition.TOP_LEFT
                };

                let options = {
                    'zoom': 12,
                    'maxZoom': 15,
                    'center': new google.maps.LatLng(12.494714, 104.310212),
                    'mapTypeId': google.maps.MapTypeId.SATELLITE,
                    'scrollwheel': false,
                    'zoomControl': true,
                    'zoomControlOptions': zoom
                };

                const map = new google.maps.Map(this.mapDiv, options);
                const bounds = new google.maps.LatLngBounds();

                if (wells) {
                    const markers = wells.map((item, index) => {
                        let pos = new google.maps.LatLng(item.lat, item.lng);
                        let marker = new google.maps.Marker({
                            'position': pos,
                            'map': this.map,
                            'icon': new google.maps.MarkerImage('/assets/marker.png', new google.maps.Size(50, 50), new google.maps.Point(0, 0), new google.maps.Point(25, 25)),
                            'title': item.title,
                            'url': item.url,
                            'label': {
                                'color': '#fff',
                                'text': '' + item.nr,
                                'fontWeight': '700'
                            }
                        });

                        google.maps.event.addListener(marker, 'click', function () {
                            window.location.href = this.url;
                        });

                        bounds.extend(pos);

                        return marker;
                    });

                    new MarkerClusterer({markers, map});
                }

                map.fitBounds(bounds);
                map.panToBounds(bounds);
            });
        }
    }
}